/** Parse a `#RGB` / `#RRGGBB` color into `[r, g, b]`; returns null for anything else. */
export const hexToRgb = (hex: string): [number, number, number] | null => {
  const match = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(hex.trim());
  if (!match?.[1]) return null;
  const h =
    match[1].length === 3 ? match[1].replace(/./g, (c) => c + c) : match[1];
  const n = parseInt(h, 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};
